// extracted by mini-css-extract-plugin
module.exports = {"startPageBackground":"styles_startPageBackground__3cq5U","fullHeight":"styles_fullHeight__35a2E"};